export default __webpack_public_path__ + "static/media/info-gray.6035dbba.svg";